/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { ChartData } from '../../../charts/models/ChartData';
import { templateParseHandler } from '../../../../../utils';

@Component({
  selector: 'app-ctr',
  templateUrl: './app-ctr.html',
  styleUrls: ['./app-ctr.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppCtr implements OnInit, OnChanges {
  @Input() domain;
  @Input() data: any;
  @Input() appName;
  @Input() isFreemium: boolean;

  headers = [];
  adSizes = [];
  percPipe = new PercPipe();
  lineChartData: Array<ChartData>;

  ngOnInit() {
    this.headers.push({
      class: 'col-4',
      text: 'CTR by Ad Size',
      key: 'adSize',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col-4 text-xs-right',
      text: 'CTR with IVT',
      key: 'ctr',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col-4 text-xs-right',
      text: 'CTR without IVT',
      key: 'nonGivtSivtCtr',
      tooltipkey: ''
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      const { adSizes, byMonth } = this.data.ctrDistribution;

      for (const adSize of adSizes) {
        const ctr = adSize['ctr'];
        adSize['ctr'] = this.percPipe.transform(ctr, '1.2-2');
        const nonGivtSivtCtr = adSize['nonGivtSivtCtr'];
        adSize['nonGivtSivtCtr'] = this.percPipe.transform(
          nonGivtSivtCtr,
          '1.2-2'
        );
      }
      this.adSizes = adSizes;

      if (byMonth) {
        this.lineChartData = JSON.parse(
          JSON.stringify(byMonth, templateParseHandler)
        );
        this.lineChartData.reverse();
      }
    }
  }
}
